import { init as skuInit } from '@/views/product/detail/components/sku-select/sku'
import { getAddressListReq } from './api'
import { formatNumber } from '@/utils/common'

export default {
  state: {
    // 一站式换新相关信息
    oneStopRenewInfo: {},
    myAddressList: [],
    recycleFormObject: null,
    oneStopRecycleVisibility: false
  },
  getters: {
    // 以旧换新库存异常与立即购买/移动特惠区分开，直接取sku字段数据
    recycleExtCode(state) {
      return state.skuInfo?.commoditySkuButton?.commodityExceptionCode
    },
    // 以旧换新活动分流的供应商
    recycleSupplierId(state) {
      return state.skuInfo.recycleOneStopActivity?.supplierId || ''
    },
    // 判断是本机，且激活时间大于6个月 - 估价信息有返回
    isSelfModel(state) {
      const recycleOneStopActivity = state.skuInfo.recycleOneStopActivity
      return recycleOneStopActivity?.recyclePrice && recycleOneStopActivity?.modelCode
    },
    isUnpublish(state) {
      return state.skuInfo?.commoditySkuBaseInfo?.salePrice === 999999
    },
    /**
     * 以旧换新活动露出判断
     * 秒杀、拼团、立即预约活动 三个入口都不露出
     * 全款预定预热状态下入口不露出
     */
    showOneStopRecycle(_, getters) {
      const { discountType, recycleExtCode, isFullPayBuy, isPreHot } = getters
      // 立即预约
      const isYuYue = recycleExtCode == 2
      return !(['group'].includes(discountType) || isYuYue || (isFullPayBuy && isPreHot))
    },
    // 配置了以旧活动 且以旧换新活动支持露出
    hasTradeInAc: (state, getters) => {
      // 以旧换新活动
      const TRADE_IN_ACTIVITY = 1
      return (
        (state.skuInfo?.commodityActivities || []).find(item => item.actType == TRADE_IN_ACTIVITY) &&
        getters.showOneStopRecycle
      )
    },
    // 活动弹层内露出判断逻辑
    tradeInAcShowPrice: (state, getters) => {
      //【1：已售罄 3：到货通知 4：下架】
      const hasStore = ![1, 3, 4].includes(getters.recycleExtCode)
      return getters.hasTradeInAc && getters.isSelfModel && !getters.isUnpublish && !getters.isDepositBuy && hasStore
    },
    tradeInSkipLink: (state, getters) => {
      if (getters.hasTradeInAc) {
        return (state.skuInfo?.commodityActivities || []).find(item => item.actType == 1).skipLink
      }
      return ''
    },
    // 配置了一站式悬浮条活动，且以旧换新活动支持露出, 且有判断是本机，且激活时间大于6个月  - 估价信息有返回, 且非全款预定和定金预售活动 且有库存
    hasActiveOneStopAc: (state, getters) => {
      // 一站式换新悬浮条
      const ONE_STOP_ACTIVITY = 6
      //【1：已售罄 3：到货通知 4：下架】
      const hasStore = ![1, 3, 4].includes(getters.recycleExtCode)
      return (
        (state.skuInfo?.commodityActivities || []).find(item => item.actType == ONE_STOP_ACTIVITY) &&
        getters.showOneStopRecycle &&
        getters.isSelfModel &&
        !getters.isUnpublish &&
        !getters.isDepositBuy &&
        hasStore
      )
    },

    isDeposit(_, getters) {
      const { discountType } = getters
      return discountType == 'deposit'
    },
    // 已选弹层展示购买方式判断 非全款预定和定金预售活动，且有以旧换新活动露出或者有悬浮条活动露出
    showRecycleBuyType: (state, getters) => {
      // 1007新增逻辑： 当切换sku时，接口未返回的情况下，不更新购买方式的展示项，避免购买方式抖动【skuSimpleChangeFlag、skuDetailChangeFlag】
      if(state.skuInfo.skuSimpleChangeFlag || state.skuInfo.skuDetailChangeFlag){
        return state.skuInfo.preShowRecycleBuyType
      }
      if (getters.isDepositBuy) return false
      // 其他情况下正常展示
      return getters.hasTradeInAc || getters.hasActiveOneStopAc
    },
    // 以旧换新活动点击跳转机型选择仅回收
    isLinkOnlyRecycle: (_, getters) => {
      const { isDepositBuy } = getters
      // 判断是否为定金预售or全款预定 - 跳转仅回收
      if (isDepositBuy) {
        return true
      }
      return false
    },
    // 6.商品异常状态（售罄、到货通知、已下架、立即预约、待发布）显示样式&跳转逻辑 以旧换新活动跳转配置页
    isLinkActivity: (_, getters) => {
      const { recycleExtCode, isUnpublish } = getters
      if (recycleExtCode || isUnpublish) {
        return true
      }
      return false
    },
    maxReward: (state, getters) => {
      // 1007新增逻辑： 当切换sku时，接口未返回的情况下，不更新购买方式的展示项，避免购买方式抖动【skuSimpleChangeFlag、skuDetailChangeFlag】
      if(state.skuInfo.skuSimpleChangeFlag || state.skuInfo.skuDetailChangeFlag){
        return state.skuInfo.preShowRecycleMaxReward
      }
      if (getters.isSelfModel) {
        const price = state.skuInfo.recycleOneStopActivity?.recycleReward || 0
        return price ? `最高补贴${price}元` : ''
      } else {
        return '享现金补贴'
      }
    },
    recycleEvaluateUrl: state => {
      return state.skuInfo.recycleOneStopActivity?.accurateEvaluatedPriceUrl || ''
    },
    renewRuleUrl: state => {
      return state.skuInfo.recycleRuleAgreement?.renewRuleUrl || ''
    },
    renewPriceLabel: (state, getters) => {
      if (getters.isSelfModel) {
        const { recyclePrice, recycleReward } = state.skuInfo.recycleOneStopActivity || {}
        const renewPrice = formatNumber(getters.totalEstimatedPrice - recyclePrice - recycleReward)
        if (renewPrice >= 0) {
          return `预估换新仅需${renewPrice}元（新机价格-回收款-换新补贴）`
        }
        return `0元购机,预估再得${Math.abs(renewPrice)}元（新机价格-回收款-换新补贴）`
      } else {
        return '以旧换新享现金补贴'
      }
    },
    renewPriceArialLabel: (state, getters) => {
      if (getters.isSelfModel) {
        const { recyclePrice, recycleReward } = state.skuInfo.recycleOneStopActivity || {}
        const renewPrice = formatNumber(getters.totalEstimatedPrice - recyclePrice - recycleReward)
        if (renewPrice >= 0) {
          return `预估换新仅需${renewPrice}元 即新机价格减回收款减换新补贴`
        }
        return `0元购机,预估再得${Math.abs(renewPrice)}元 即新机价格减回收款减换新补贴`
      } else {
        return '以旧换新享现金补贴'
      }
    },
    renewPriceActivityPopupLabel: (state, getters) => {
      if (getters.isSelfModel) {
        const { recyclePrice, recycleReward } = state.skuInfo.recycleOneStopActivity || {}
        const renewPrice = formatNumber(getters.totalEstimatedPrice - recyclePrice - recycleReward)
        if (renewPrice > 0) return `预估换新仅需<span class="yuan">${renewPrice}</span>元`
        else if (renewPrice == 0) return `0元购新机`
        else return `0元购机,预估再得<span class="yuan">${Math.abs(renewPrice)}</span>元`
      } else {
        return ''
      }
    },
    renewPriceActivityPopupLabelAndReward: (state, getters) => {
      if (getters.renewPriceActivityPopupLabel) {
        const { recycleReward } = state.skuInfo.recycleOneStopActivity || {}
        return getters.renewPriceActivityPopupLabel + (recycleReward ? `（换新补贴最高${recycleReward}元）` : '')
      } else {
        return ''
      }
    },
    totalEstimatedPrice: (state, getters) => {
      // 如果是套餐，则不管是否抢购状态，都取套餐价, 最终到手价= (套餐价+服务总价)*数量
      if (state.selectParams.currentSuite?.id) {
        return (state.selectParams?.currentSuite?.totalPrice + getters.totalServicePrice) * state.selectParams.number
      }
      if (
        getters.totalServicePrice > 0 ||
        state.selectParams?.fqNum != 0 ||
        !getters.commodityEstimated?.commodityEstimatedPrice
      ) {
        return getters.totalPrice
      }
      return (
        (getters.commodityEstimated?.commodityEstimatedPrice + getters.totalServicePrice) * state.selectParams.number
      )
    },
    productRecycleInfo(state, getters) {
      const {
        machineCode: modelCode,
        machineName: modelName,
        memberLevel,
        levelIconWithTextUrl,
        levelIconUrl,
        oldModelImage: modelImgUrl,
        recyclePrice,
        recycleReward,
        fixedReward,
        memberReward
      } = state.skuInfo.recycleOneStopActivity || {}
      return {
        skuId: getters.skuId,
        selectAddressData: state.addressData,
        formateInfo: {
          commoditySvcs: state.spuInfo?.commoditySvcs,
          skuName: state.skuInfo?.commoditySkuBaseInfo?.skuName,
          suites: state.skuInfo?.commoditySkuDiscount?.commoditySuite,
          img: state.skuInfo?.imageInfos[0].smallPic,
          totalPrice: getters.totalPrice,
          finalPrice: getters.totalEstimatedPrice,
          salePrice: state.skuInfo.commoditySkuBaseInfo.salePrice
        },
        spuInfo: state.spuInfo,
        skuInfo: state.skuInfo,
        selectParams: state.selectParams,
        evaluateParams: {
          modelName,
          modelCode,
          memberLevel,
          levelIconWithTextUrl,
          levelIconUrl,
          modelImgUrl,
          recyclePrice,
          recycleReward,
          fixedReward,
          memberReward,
          renewType: 1 // 1: 延迟补贴 2:一站式换新
        } // 分流估价数据 - 估价结果页
      }
    },
    // 新机图片
    newModelImg(state, _) {
      return state.skuInfo?.imageInfos[0].smallPic
    }
  },
  actions: {
    // 简化版init 首屏数据
    firstScreenInit({ dispatch, commit, state, getters }, params) {
      return Promise.all([
        dispatch('getSimpleSpu', params),
        dispatch('getSimpleSku', params),
        dispatch('getDetailSpu', params)
      ]).then(() => {
        skuInit({
          spuInfo: state.spuInfo,
          skuInfo: state.skuInfo,
          skuId: state.skuInfo.commoditySkuBaseInfo.skuId
        })
      })
    },
    setOneStopRenewInfo({ commit }, params) {
      commit('UPDATE_ONE_STOP_RENEW_INFO', params)
    },
    setFormObject({ commit }, params) {
      commit('SET_FORM_OBJECT', params)
    },
    getRecyleAdsList({ commit }) {
      return new Promise((resolve, reject) => {
        getAddressListReq()
          .then(res => {
            commit('SET_MY_ADDRESS_LIST', res)
            resolve(res)
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  mutations: {
    SET_FORM_OBJECT(state, params) {
      state.recycleFormObject = params
    },
    UPDATE_ONE_STOP_RENEW_INFO(state, params) {
      state.oneStopRenewInfo = {
        ...state.oneStopRenewInfo,
        ...params
      }
    },
    SET_MY_ADDRESS_LIST(state, list) {
      state.myAddressList = list
    },
    ONE_STOP_RECYCLE_VISIBILITY(state, flag) {
      state.oneStopRecycleVisibility = flag
    }
  }
}
